'use client';

import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { WAITER_LOCALE_CATALOGS } from '@config/localeCatalogs.config';
import { usePersistence } from '@segments/Storage';
import * as React from 'react';
import { ClientAppRoot } from '~logic/appRoots/ClientAppRoot';
import { useConfigCtx } from '../ConfigContext/ConfigProvider';
import { useResolvedCompanyCtx } from '../ResolvedCompanyContext/ResolvedCompanyProvider';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Group of logic providers as auth, i18n and gql apollo.
 */
export var WaiterRoot = function WaiterRoot(_ref) {
  var children = _ref.children;
  var config = useConfigCtx();

  var _useResolvedCompanyCt = useResolvedCompanyCtx(),
      selectedLanguage = _useResolvedCompanyCt.selectedLanguage;

  var _usePersistence = usePersistence({
    key: 'auth'
  }),
      _usePersistence2 = _slicedToArray(_usePersistence, 2),
      getStoredAuthContext = _usePersistence2[0],
      storeAuthContext = _usePersistence2[1];

  return /*#__PURE__*/_jsx(ClientAppRoot, {
    localeCatalogs: WAITER_LOCALE_CATALOGS,
    backendUrl: config.backendUrl,
    activeLocale: selectedLanguage.code,
    initAuthContext: getStoredAuthContext,
    onAuthContextChange: storeAuthContext,
    isLoginEnabled: false,
    loadingFallback: /*#__PURE__*/_jsx("b", {
      children: "Loading..."
    }),
    children: children
  });
};